/**
 * Product page gallery foot (snippets/pdp-gallery-foot.liquid).
 *
 * The counter follows the image the theme's media-gallery marks active, and "All angles"
 * opens the theme's own lightbox at the first image. Nothing here replaces the gallery's
 * behaviour; it only reads it.
 */
(() => {
  const init = (foot) => {
    const wrapper = foot.closest('.product__media-wrapper');
    if (!wrapper) return;
    const current = foot.querySelector('[data-pdp-count-current]');
    const items = () => [...wrapper.querySelectorAll('.product__media-list > .product__media-item')];

    const update = () => {
      const list = items();
      const active = list.findIndex((item) => item.classList.contains('is-active'));
      if (current) current.textContent = String((active < 0 ? 0 : active) + 1);
    };

    const list = wrapper.querySelector('.product__media-list');
    if (list) {
      new MutationObserver(update).observe(list, { subtree: true, attributes: true, attributeFilter: ['class'] });
      // On a phone the main image is a swipe slider rather than an active class.
      list.addEventListener('scroll', () => {
        const all = items();
        const width = list.clientWidth || 1;
        const index = Math.round(list.scrollLeft / width);
        if (current && all.length) current.textContent = String(Math.min(index, all.length - 1) + 1);
      }, { passive: true });
    }
    update();

    const angles = foot.querySelector('[data-pdp-all-angles]');
    if (angles) {
      angles.addEventListener('click', () => {
        const opener = wrapper.querySelector('.product__media-toggle');
        if (opener) opener.click();
      });
    }
  };

  const start = () => document.querySelectorAll('[data-pdp-gallery-foot]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/**
 * "Sizing & fit" and "Need help with your size?" open the page's Sizing row and bring it
 * into view. A product without a Sizing row hides "Sizing & fit", and the help link goes to
 * client services instead.
 */
(() => {
  const sizingRow = () =>
    [...document.querySelectorAll('.product__info-container .product__accordion details')].find((details) =>
      /sizing|size/i.test(details.querySelector('summary')?.textContent || '')
    );

  const wire = () => {
    const row = sizingRow();
    document.querySelectorAll('[data-pdp-open-sizing]').forEach((trigger) => {
      if (trigger.dataset.pdpWired) return;
      trigger.dataset.pdpWired = 'true';
      if (!row) {
        if (trigger.dataset.pdpFallback) {
          trigger.addEventListener('click', () => (window.location.href = trigger.dataset.pdpFallback));
        } else {
          trigger.hidden = true;
        }
        return;
      }
      trigger.addEventListener('click', () => {
        row.open = true;
        row.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire);
  else wire();
  // Variant changes re-render the picker; wire the new trigger.
  document.addEventListener('variant:change', () => setTimeout(wire, 50));
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      wire();
    });
  }).observe(document.querySelector('.product__info-container') || document.body, { childList: true, subtree: true });
})();
